import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Center } from '../../../model/center';
import { CenterFilter } from '../../../model/center-filter';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-billing-medical-appointment-procedure-edit-dialog',
  templateUrl: './billing-medical-appointment-procedure-edit-dialog.component.html',
  styleUrls: ['./billing-medical-appointment-procedure-edit-dialog.component.css']
})
export class BillingMedicalAppointmentProcedureEditDialogComponent implements OnInit {

  form: FormGroup;
  centers: CenterFilter[] = [];

  constructor(public dialogRef: MatDialogRef<BillingMedicalAppointmentProcedureEditDialogComponent>,
    private filterService: FilterService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: BillingMedicalAppointmentProcedureEditRequest) {

      this.form = this.formBuilder.group({
        invoicingCenter: ['' , [Validators.required]],
        invoicingDate: ['' , [Validators.required]]
      });
    }

  get f() { return this.form.controls; }

  ngOnInit() {
    this.filterService.getCentersFilter()
      .then(info => this.centers = info);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close(<BillingMedicalAppointmentProcedureEditResponse>this.form.getRawValue());
    }
  }
}

export interface BillingMedicalAppointmentProcedureEditRequest {
  invoicingCenter: CenterFilter;
  invoicingDate?: Date;
}

export interface BillingMedicalAppointmentProcedureEditResponse {
  invoicingCenter: CenterFilter;
  invoicingDate: Date;
}
